import { Grid, CardContent } from "@mui/material";
import { IFullFlight } from "@vmosolutions/oc-interfaces";
import { FormHeader } from "../helpers";
import { DisplayContent } from "src/pages/FlightEditor/Content/DisplayContent";

interface IContentTabProps {
  fullFlight: IFullFlight; // Id of the flight to retrieve and edit if provided.
  updateTabState: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  path: string[];
  setAPICallStatus: (statusMessage: string) => void;
  setLoadedEvent?: any;
}

/**
 * Flight Content Tab
 * @param props -
 */
export const ContentTab = (props: IContentTabProps): JSX.Element => {
  const { fullFlight, updateTabState, mosaicId, path, setAPICallStatus, setLoadedEvent } = props;
  const { _id, content } = fullFlight ?? {};

  return (
    <CardContent id={`${mosaicId}-content-editor`} className="form_card content">
      <Grid container direction="column">
        <FormHeader title="Content" subtitle="" />
        {fullFlight ? (
          <DisplayContent
            path={path}
            flightId={_id}
            content={content}
            flight={fullFlight}
            setLoadedEvent={setLoadedEvent}
          />
        ) : null}
      </Grid>
    </CardContent>
  );
};
